import { connect } from 'react-redux';
import RemediesForm from './RemediesForm';
import React, { useState, useEffect } from 'react';
import { constant } from '../../../Utils/constants';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';
import { getCauseCodes, insertModalData } from '../../../Utils/FormCalls';
import { QuestionCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { Form, Collapse, Popconfirm, Select, Divider, Space, message, Tooltip, Modal,Button } from 'antd';
import { StyledBox } from '../../../CSS/style';

const { Panel } = Collapse;
const { Option } = Select;
const ActionType = 'create';
const CauseMaster = 'Cause_Codes';
const CausesForm = (props) => {
  const [CausesList, setCauses] = useState([]);
  const [Visible, setVisible] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  useEffect(() => {
    (async () => {
      try {
        let response = await getCauseCodes();
        setCauses(response);
      } catch (e) {
        return {};
      }
    })();
  }, []);

  const CauseModalRef = React.createRef();

  function onCauseModalOpen() {
    setVisible(true);
  }
  const onCauseModalSubmit = async (e) => {
    e.preventDefault();
    // let data = CauseModalRef.current.getFieldValue();
    // let payloadCause = data;
    // let statusModal = await insertModalData(CauseMaster, ActionType, payloadCause);
    // setVisible(false);
    // if (statusModal && statusModal.message) {
    //   message.success(statusModal.message);
    //   if (CauseModalRef.current) CauseModalRef.current.resetFields();

    //   let list = await getCauseCodes();
    //   setCauses(list);
    // } else if (statusModal && statusModal.Error) {
    //   message.error(statusModal.Error);
    // }
    CauseModalRef.current
      .validateFields()
      .then(async (values) => {
        let payload = {
          ...values
        };
        let response = await insertModalData(CauseMaster, ActionType, payload);
        setVisible(false);
        if (response && response.message) {
          message.success(response.message);
          if (CauseModalRef.current) CauseModalRef.current.resetFields();
          let list = await getCauseCodes();
          setCauses(list);
        } else if (response && response.Error) {
          message.error(response.Error);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function onCancel(e) {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Click On Cancel');
    } else {
      setVisible(false);
    }
  }
  /* eslint-disable no-template-curly-in-string */
  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    }
    // pattern: {
    //   mismatch: '${label} does not match pattern'
    // }
  };
  return (
    <>
      <div>
        <>
          <div>
            <Form.List name={[props.fieldKey, 'Causes']}>
              {(Causes, { add }) => (
                <>
                  <div style={{ display: 'flex', justifyContent: 'right' }}>
                    <Form.Item>
                      <Button
                      style={{margin:'10px 0px'}}
                       onClick={() => add()}
                      // icon={<PlusOutlined />}
                      >
                        {translation(translationCache, constant.addCause)}
                      </Button>
                    </Form.Item>
                  </div>
                  {Causes && Array.isArray(Causes) && Causes.length > 0 ? (
                    <Collapse accordion defaultActiveKey={[]}>
                      {Causes.map((cause, index2) => (
                        <Panel
                          key={index2}
                          header={`${translation(translationCache, 'Cause')} ${index2 + 1}`}
                          extra={
                            <Popconfirm
                              title={translation(
                                translationCache,
                                'Are you sure that you want to delete the cause'
                              )}
                              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                              // onConfirm={() => remove(cause.name)}
                              onConfirm={() => props.onRemove(props.fieldKey, index2, 'Causes')}
                              okText={translation(translationCache, constant.yes)}
                              cancelText={translation(translationCache, constant.no)}
                            >
                              <Tooltip
                                title={translation(translationCache, 'Delete')}
                                placement="bottom"
                              >
                                <DeleteOutlined />
                              </Tooltip>
                            </Popconfirm>
                          }
                        >
                          <StyledBox>
                            <Form.Item
                              {...cause}
                              label={translation(translationCache, constant.causeCode)}
                              name={[cause.name, 'CauseId']}
                              fieldKey={[cause.fieldKey, 'Cause Code']}
                              key={index2}
                              rules={[
                                { required: true }
                              ]}
                            >
                              <Select
                                onChange={(value) =>
                                  props.onCauseChange(
                                    value,
                                    'Problems',
                                    props.fieldKey,
                                    'Causes',
                                    index2,
                                    CausesList.filter((cause) => cause.Id === value),
                                    Causes
                                  )
                                }
                                style={{ width: '100%' }}
                                placeholder={translation(translationCache, 'Select Cause')}
                                dropdownRender={(menu) => (
                                  <>
                                    {menu}
                                    <Divider
                                      style={{
                                        margin: '8px 0'
                                      }}
                                    />
                                    <Space
                                      style={{
                                        padding: '0 8px 4px'
                                      }}
                                    >
                                      <Button
                                        type="dashed"
                                        // icon={<PlusOutlined />}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          onCauseModalOpen();
                                        }}
                                      >
                                        {translation(translationCache, constant.addCause)}
                                      </Button>
                                    </Space>
                                  </>
                                )}
                              >
                                {CausesList &&
                                  Array.isArray(CausesList) &&
                                  CausesList.map((causes, i) => {
                                    return (
                                      <Option
                                        key={i}
                                        value={causes.Id}
                                        disabled={
                                          props &&
                                            props.formObject &&
                                            props.formObject.Problems &&
                                            props.formObject.Problems[props.fieldKey] &&
                                            props.formObject.Problems[props.fieldKey].Causes &&
                                            props.formObject.Problems[props.fieldKey].Causes.filter(
                                              (failure) => failure && failure.CauseId === causes.Id
                                            ).length > 0
                                            ? true
                                            : false
                                        }
                                      >
                                        {' '}
                                        {causes.CauseCode}{' '}
                                      </Option>
                                    );
                                  })}
                              </Select>
                            </Form.Item>
                            <Form.Item
                              {...cause}
                              // style={{ marginLeft: '20px' }}
                              label={translation(translationCache, 'Description')}
                              name={[cause.name, 'Description']}
                              fieldKey={[cause.fieldKey, 'Description']}
                              key={index2}
                              rules={[{ required: false }]}
                            >
                              <InputComponent
                                placeholder={translation(
                                  translationCache,
                                  'Autopopulate based on Cause'
                                )}
                                disabled={true}
                                // maxLength={150}
                                style={{ width: '100%' }}
                              />
                            </Form.Item>
                            <Form.Item
                              {...cause}
                              // style={{ marginLeft: '20px' }}
                              label={translation(translationCache, constant.Remarks)}
                              name={[cause.name, 'Remarks']}
                              fieldKey={[cause.fieldKey, 'Remarks']}
                              key={index2}
                            >
                              <InputComponent
                                placeholder={translation(translationCache, 'Input Remarks')}
                                // maxLength={150}
                                style={{ width: '100%' }}
                              />
                            </Form.Item>
                            {Visible === true ? (
                              <Modal
                                width={800}
                                closable
                                title={translation(translationCache, constant.newCause)}
                                open={Visible}
                                onCancel={onCancel}
                                footer={[
                                  <Button key={2} onClick={onCancel}>
                                    {translation(translationCache, constant.cancel)}
                                  </Button>,
                                  <Button
                                    key={1}
                                    onClick={(e) => {
                                      onCauseModalSubmit(e);
                                    }}
                                  >
                                    {translation(translationCache, constant.submit)}
                                  </Button>
                                ]}
                              >
                                {/* <Form
                                                                ref={CauseModalRef}
                                                                onFinish={onCauseModalSubmit}
                                                                // onFinishFailed={this.onFinishFailed}
                                                                // initialValues={formObject}
                                                                layout="vertical"
                                                            > */}
                                <Form
                                  name="Item"
                                  ref={CauseModalRef}
                                  // initialValues={formObject}
                                  // onFinish={this.onFinish}
                                  layout="vertical"
                                  // labelCol={{ flex: '130px' }}
                                  labelAlign="right"
                                  labelWrap
                                  //wrapperCol={{ flex: 1 }}
                                  validateMessages={validateMessages}
                                >
                                  <Form.Item
                                    style={{ width: '100%', flex: '50%' }}
                                    label={translation(translationCache, constant.newCauseCode)}
                                    name="CauseCode"
                                    rules={[
                                      { required: true },
                                      {
                                        // pattern: new RegExp(/^[A-Za-z0-9-_& ]*$/)
                                        // pattern: new RegExp(
                                        //   /^[一-龯ぁ-んァ-ン-_&0-9A-Za-zァ-ヶ ]*$/
                                        // )
                                      }
                                    ]}
                                  >
                                    <InputComponent
                                      placeholder={translation(
                                        translationCache,
                                        'Input Cause Code'
                                      )}
                                      style={{ width: '70%' }}
                                    //  / maxLength={50}
                                    />
                                  </Form.Item>

                                  <Form.Item
                                    style={{ width: '100%', flex: '50%' }}
                                    label={translation(translationCache, 'Description')}
                                    name="Description"
                                    rules={[
                                      {
                                        required: true,
                                        message: translation(
                                          translationCache,
                                          'Description is required'
                                        )
                                      },
                                      {
                                        // pattern: new RegExp(/^[A-Za-z0-9-_& ]*$/)
                                        // pattern: new RegExp(
                                        //   /^[一-龯ぁ-んァ-ン-_&0-9A-Za-zァ-ヶ ]*$/
                                        // )
                                      }
                                    ]}
                                  >
                                    <InputComponent
                                      placeholder={translation(
                                        translationCache,
                                        'Input Description'
                                      )}
                                      style={{ width: '70%' }}
                                    // maxLength={150}
                                    />
                                  </Form.Item>
                                </Form>
                              </Modal>
                            ) : (
                              ''
                            )}
                          </StyledBox>
                          <Form.Item>
                            <RemediesForm
                              problemIndex={props.fieldKey}
                              causeIndex={cause.name}
                              onRemedieChange={props.onRemedieSelect}
                            />
                          </Form.Item>
                        </Panel>
                      ))}
                    </Collapse>
                  ) : null}
                </>
              )}
            </Form.List>
          </div>
        </>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};
export default connect(mapStateToProps)(CausesForm);
